module.exports = {"pathContext":{"name":"PlainDecimal","kind":"SCALAR","type":"OBJECT","fields":null,"description":"An arbitrary-precision decimal serialized in plain (non-scientific) notation.\n\nThe default `:decimal` scalar delegates to `Decimal.to_string/1`, which uses\n`:scientific` notation in `Decimal` v2 (e.g. `1E-9`). Microdose values must\nreach the UI as a human-readable string like `0.000000001`, so this scalar\nforces `:normal` notation on serialize. Parsing is identical to `:decimal`.","enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/scalar-plain-decimal.json
// module id = 2133
// module chunks = 245643399531540